import * as Role from '../constants/role';
import { CONFORMIDADE_INSPECAO_ADMIN } from '../constants/modules';
import { hasModuleConfiguration } from './moduleConfigurationPermission';
import { isUsuarioSupervisor } from './inspecaoReportPermission';

/**
 * Quem vê /v2/relatorio-conformidade-inspecao (menu + tela).
 * Mesmo padrão de `canLiberarDigitacaoAntecipada`:
 * - ROLE_SUPER_ADMIN
 * - flag `authData.supervisor`
 * - module_configuration `CONFORMIDADE_INSPECAO_ADMIN`
 *
 * ROLE_ADMIN sozinho não libera — precisa da flag supervisor ou do módulo.
 */
export function canViewConformidadeInspecao({ authData, moduleConfigurations }) {
  return authData?.role === Role.SUPER_ADMIN
    || isUsuarioSupervisor(authData)
    || hasModuleConfiguration(moduleConfigurations, authData, CONFORMIDADE_INSPECAO_ADMIN);
}
